export const presetCxpSessionId = state => state.presetCxpSessionId;
